import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import MobileAppsSection from "@/components/landing/MobileAppsSection";
import BenefitsSection from "@/components/landing/BenefitsSection";
import PartnersAwardsSection from "@/components/landing/PartnersAwardsSection";
import CTASection from "@/components/landing/CTASection";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-pure-white to-electric-blue/10 text-midnight-blue">
      <HeroSection />
      <FeaturesSection />
      <MobileAppsSection />
      <BenefitsSection />
      <PartnersAwardsSection />
      <CTASection />
    </div>
  );
}
